import { createAction } from '@reduxjs/toolkit';
export const UPDATE_ANALYTIC_TEAM_MEMBER = 'UPDATE_ANALYTIC_TEAM_MEMBER';
export const updateAnalyticTeamMemberAction = createAction(UPDATE_ANALYTIC_TEAM_MEMBER);
